import {Grid, Paper, TextField} from '@material-ui/core';
import React, {Fragment, useEffect, useMemo, useState} from 'react';
import {ComboSelect, FormCheckbox, FormDialog, FormMemo, MaskedNumber, MaskedText} from "../../../controls";
import Validator from "../validators/AllocateStockDialogValidator";
import CompanyUuidLookup from "../../Companies/components/CompanyUuidLookup";
import Draggable from "react-draggable";
import AirportsLookup from '../../Airports/components/AirportsLookup';
import __ from "lodash";

const PaperComponent = (props) => {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const AllocateStockDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;
  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    title: 'Allocate AWB Stock',
    quantityToAllocate: null,
    currentAllocation: null,
    selectCompany: null,
  });

  const DisplayForm = () => {

    return (
      <FormDialog
        title={dialogState.title}
        message=""
        open={dialogState.showDialog}
        record={{awbPrefix: "", quantityToAllocate: dialogState.quantityToAllocate, companyUuid: null, selectCompany: dialogState.selectCompany, "aria-labelledby": "draggable-dialog-title", useStartingAwb: false, startingAwb: null, airportCode: '', canChangeAirport: false, allocationNote: ''}}
        dialogOptions={{maxWidth: "sm", fullWidth: false, PaperComponent: PaperComponent}}
        classes={classes}
        validator={Validator}
        buttons = {{
          save:{icon: "check_circle", key: "Allocate", label: "Allocate", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            if (record.quantityToAllocate) {
              if (typeof props.onClose === 'function') {
                props.onClose(record.quantityToAllocate, dialogState.currentAllocation, record).then(closeDialog => {
                  if (closeDialog) {
                    setDialogState({...dialogState, showDialog: false, awbPrefix: "", selectCompany: false, currentAllocation: null});
                  }  
                });
              } else {
                setDialogState({...dialogState, showDialog: false, awbPrefix: "", selectCompany: false, currentAllocation: null});
              }
            }
          } else {
            setDialogState({...dialogState, showDialog: false, awbPrefix: "", selectCompany: false, currentAllocation: null});
          }
        }}
      >
        <Grid container checkChildren={true} spacing={3} style={dialogState.selectCompany ? { minWidth: 500} : { minWidth: 300}}>
        {dialogState.selectCompany
            ?
              <Grid item xs={9} checkChildren={true}>
                <CompanyUuidLookup
                  companyType={"CLIENT"}
                  id="companyUuid"
                  label="Allocate To"
                  shrink={true}
                  readOnly={false}
                  returnType={"object"}
                  onChange={(returnObject, props) => {
                    if (returnObject.found) {
                      const company = returnObject.data
                      const data = {
                        ...props.record,
                        companyName: company.companyName,
                        companyUuid: company.companyUuid,
                        airportCode: company.branchCode||'',
                        canChangeAirport: __.isEmpty(company.branchCode)
                      }
                      props.recordChange(data);
                    } else {
                      props.onChange(returnObject.value);
                    }
                  }}
                />
              </Grid>
            :
              <></>
          }
          {dialogState.selectCompany
            ?
              <Grid item xs={3} checkChildren={true}>
                {rowData => (
                  <AirportsLookup
                    id="airportCode"
                    label="Airport"
                    shrink={true}
                    readOnly={!rowData.canChangeAirport}
                  />
                )}
              </Grid>
            :
              <></>
          }
          {dialogState.selectCompany
            ?
              <Grid item xs={6} checkChildren={true}>
                <ComboSelect
                  id="awbPrefix"
                  label="Stock"
                  group="AWB STOCK"
                  subGroup="PREFIX"
                  fullWidth
                />
              </Grid>
            :
              <></>
          }

          <Grid item xs={dialogState.selectCompany ? 6 : 12} checkChildren={true}>
            <MaskedNumber
              id="quantityToAllocate"
              label="Quantity to Allocate"
              decimalScale={0}
              fixedDecimalScale={true}
              style={{fontSize: "0.875rem", ...props.style}}
              fullWidth
              valueCap={5000}
            />
          </Grid>
          {props.canAddOldStock && dialogState.selectCompany ? 
            <Grid item xs={6} checkChildren={true}>
              <FormCheckbox
                id="useStartingAwb"
                label="Assign Old Stock"
                style={{fontSize: "0.875rem", ...props.style}}
                checked={false}
              />
            </Grid>
           : <></>}
           {props.canAddOldStock && dialogState.selectCompany ? 
            <Grid item xs={6} checkChildren={true}>
              {rowData => (
                  <MaskedNumber
                    id="startingAwb"
                    label="Starting AWB"
                    decimalScale={0}
                    fixedDecimalScale={true}
                    thousandsGroupStyle=""
                    thousandSeparator=""
                    style={{fontSize: "0.875rem", ...props.style}}
                    valueCap={9999999}
                    fullWidth
                    disabled={!rowData.useStartingAwb}
                  />
                )
              }
            </Grid> 
            : <></>}
            <Grid item xs={12} checkChildren={true}>
              <FormMemo
                id="allocationNote"
                label="Note"
                readOnly={false}
                shrink={true}
              />
            </Grid>
        </Grid>
      </FormDialog>
    )
  }

  useEffect(()=> {
    const open = async (params) => {
      const {title, canEdit, currentAllocation} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, title, currentAllocation});
    }
    const openCompany = async (params) => {
      const {title, canEdit, currentAllocation} = params;
      setDialogState({...dialogState, showDialog: true, selectCompany: true, canEdit, title, currentAllocation});
    }
    eventBus.bind("AllocateStockDialog.open", open);
    eventBus.bind("AllocateCompanyStockDialog.open", openCompany);
    return () => {
      eventBus.unbind("AllocateStockDialog.open", open);
      eventBus.unbind("AllocateCompanyStockDialog.open", openCompany);
    }
  }, [dialogState, eventBus]);

  if (dialogState.showDialog) {
    return (
      <DisplayForm />
    )
  }
  return (<></>);
}

export default AllocateStockDialog;
